export const normalizeNewLines = (content) => {
    if (!content) { return ""; }
    return content.replace(/(?:\\[rn]|[\r\n]+)+/g, "\n");
  }

  
